import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, modal} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import * as objednavkaActions from "../actions/objednavkaActions";
import KontaktniInformaceForm from "../forms/operator/KontaktniInformaceForm";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující kontaktní informace objednávky.
 */
class KontaktniInformacePanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
        readOnly: PropTypes.bool, // zda je panel v režimu read-only, tj. nezobrazuje tlačítko pro úpravu, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    handleUpravit = () => {
        const {objednavka, t} = this.props;
        const {uzivatelObjednalId, uzivatelObjednalJmeno, spolecnostId, kartaId, email, telefon, notifikaceEmail, notifikaceSms} = objednavka;
        const editKontaktVo = {uzivatelObjednalId, uzivatelObjednalJmeno, spolecnostId, kartaId, email, telefon, notifikaceEmail, notifikaceSms};
        this.props.dispatch(modal.ModalActions.show(
            KontaktniInformaceForm,
            {
                onSubmit: (data) => {
                    return ObjednavkaApi.updateObjednavkaKontakt(objednavka.id, data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                    objednavkaActions.notifyIfNeeded(result);
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: editKontaktVo
            },
            t('contact_information_edit'),
            {size: "md"}
        ));
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return !readOnly ? <ButtonToolbar>
            <Button onClick={this.handleUpravit}>{t('edit')}</Button>
        </ButtonToolbar> : null;
    };

    render() {
        const {objednavka, t} = this.props;

        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('contact_information')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={4}>
                        <DetailValue label={t('firstname_and_surname')}>{objednavka.uzivatelObjednalJmeno}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('email')}>{objednavka.email}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('phone')}>{objednavka.telefon}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('company')}>{objednavka.nazevSpolecnost}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('notification_email')}>{objednavka.notifikaceEmail ? t('yes') : t('no')}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue label={t('notification_sms')}>{objednavka.notifikaceSms ? t('yes') : t('no')}</DetailValue>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(KontaktniInformacePanel));
